var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetaDireita(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98924 3.49932C7.8584 3.63327 7.78516 3.81308 7.78516 4.00032C7.78516 4.18756 7.8584 4.36737 7.98924 4.50132L15.2987 11.9998L7.98924 19.4968C7.8584 19.6308 7.78516 19.8106 7.78516 19.9978C7.78516 20.185 7.8584 20.3649 7.98924 20.4988C8.05283 20.5641 8.12886 20.616 8.21285 20.6515C8.29684 20.6869 8.38707 20.7052 8.47824 20.7052C8.5694 20.7052 8.65963 20.6869 8.74362 20.6515C8.82761 20.616 8.90364 20.5641 8.96724 20.4988L16.7402 12.5233C16.8768 12.3833 16.9532 12.1954 16.9532 11.9998C16.9532 11.8042 16.8768 11.6164 16.7402 11.4763L8.96724 3.50082C8.90364 3.4355 8.82761 3.38359 8.74362 3.34814C8.65963 3.3127 8.5694 3.29443 8.47824 3.29443C8.38707 3.29443 8.29684 3.3127 8.21285 3.34814C8.12886 3.38359 8.05283 3.4355 7.98924 3.50082V3.49932Z",
    fill: "#215044"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaDireita);
export default __webpack_public_path__ + "static/media/setaDireita.508a7ef4943683151eeca1344d33ae33.svg";
export { ForwardRef as ReactComponent };